<template lang="pug">
.v-field-tumbler-list.field-tumbler-list
	label.field-tumbler-list__label(v-if="field.label" :id="uniqueId") {{field.label}}
	.field-tumbler-list__item.flc(v-for="(option, index) in field.options" :key="option.value + '-' + index")
		v-field-tumbler(
				:true-value="option.value"
				:text="option.text"
				:disabled="option.disabled || field.disabled"
				v-model="localValue"
				@update:model-value="handleInput")
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId';

export default {
	props: {
		radio: {
			type: Boolean,
			default: false
		},

		field: {
			type: Object,
			required: true,
			default: null
		},

		modelValue: {
			type: [Object, String, Number, Boolean],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			open: false,
			uniqueId: uniqueId('field-')
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
		}
	},
};
</script>
